module.exports = __webpack_public_path__ + "static/media/slider2.6508f3bf.png";